import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import {
  IGlobalCompaniesState,
  IGlobalCompanyContactsState,
  IGlobalConfigurationState,
  IGlobalSocialNetworksState,
  selectCompanyContacts,
  selectCompanyList,
  selectConfiguration,
  selectSocialNetworks,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import PropertyEditPage from '../components/PropertyEditPage'
import {
  actionCreators,
  IPropertyEditState,
  selectCanSave,
  selectError,
  selectIsLoading,
  selectIsReady,
  selectIsSaving,
  selectProperty,
} from '../modules/propertyEdit'

type IComponentState = IPropertyEditState &
  ICurrentUserState &
  IGlobalCompanyContactsState &
  IGlobalConfigurationState &
  IGlobalSocialNetworksState &
  IGlobalCompaniesState

export default withRouter(
  connect(
    createStructuredSelector<ApplicationState, IComponentState>({
      canSave: selectCanSave(),
      companies: selectCompanyList(),
      companyContacts: selectCompanyContacts(),
      configuration: selectConfiguration(),
      error: selectError(),
      isLoading: selectIsLoading(),
      isReady: selectIsReady(),
      isSaving: selectIsSaving(),
      property: selectProperty(),
      socialNetworks: selectSocialNetworks(),
      user: selectCurrentUser(),
    }),
    actionCreators,
  )(PropertyEditPage),
)
